import { createContext, useContext } from 'react';

export interface IUiConfigContext {
  sidebarTitle: string;
  sidebarLogoUrl: string | null;
  faviconUrl: string | null;
  documentTitle: string;
  footerText: string;
}

export const DEFAULT_UI_CONFIG: IUiConfigContext = {
  sidebarTitle: 'Abstract',
  sidebarLogoUrl: null,
  faviconUrl: null,
  documentTitle: 'Client App',
  footerText: 'Abstract © {{year}} | Sva prava zadržana.',
};

export const UiConfigContext = createContext<IUiConfigContext>(DEFAULT_UI_CONFIG);

UiConfigContext.displayName = 'UiConfigContext';

export const useUiConfig = () => useContext(UiConfigContext);
